import React from "react";
import { LegalLayout, H2, P, UL } from "../components/LegalLayout";
import Seo from "../components/Seo";

export default function PrivacyPolicy() {
    return (
        <>
            <Seo
                path="/privacy-policy"
                title="Privacy Policy — Free AI Writers"
                description="Read the Privacy Policy of Free AI Writers. Learn what information we collect, how we use it, and the choices you have. We do not sell your data."
            />
            <LegalLayout
            kicker="Legal"
            title="Privacy Policy"
            lastUpdated="February 2026"
        >
            <P>
                At <b>Free AI Writers</b> (the "Site"), accessible from
                freeaiwriters.com, we take your privacy seriously. This Privacy
                Policy explains what information we collect, how we use it, and
                the choices you have. By using our Site, you agree to the
                practices described below.
            </P>

            <H2>1. Information We Collect</H2>
            <P>
                Free AI Writers does not require you to create an account or
                provide personal information to use our tools. However, like most
                websites, we automatically collect certain non-personally
                identifiable information when you visit, including:
            </P>
            <UL>
                <li>Browser type, language, and operating system</li>
                <li>Device type (mobile, desktop, tablet)</li>
                <li>Approximate location (country / region) via IP</li>
                <li>Pages you view and time spent on each page</li>
                <li>Referring website (how you arrived at our site)</li>
            </UL>

            <H2>2. AI-Generated Content</H2>
            <P>
                When you use one of our 100+ AI tools, the text or image prompt
                you submit is sent to a third-party AI provider (OpenAI, Google
                Gemini, Anthropic Claude, or similar) to generate a response. We
                do <b>not</b> retain the content of your prompts beyond what's
                strictly required for the tool to function. AI providers may
                process your input under their own privacy policies.
            </P>

            <H2>3. Cookies & Analytics</H2>
            <P>
                We use cookies and similar technologies to understand how visitors
                use our site and improve the experience. We may use:
            </P>
            <UL>
                <li>
                    <b>Ezoic</b> — for traffic analytics and ad management
                </li>
                <li>
                    <b>Google Analytics</b> — for aggregated visitor statistics
                </li>
                <li>
                    <b>Cookie consent (CMP)</b> — to comply with GDPR/CCPA
                </li>
            </UL>
            <P>
                You can disable cookies through your browser settings. Doing so
                may affect site functionality.
            </P>

            <H2>4. Advertising</H2>
            <P>
                Our site may display third-party advertisements (e.g. via Ezoic,
                Google AdSense). These services may use cookies to serve ads
                based on your prior visits to our site or other websites. You can
                opt out of personalized advertising by visiting Google's Ads
                Settings.
            </P>

            <H2>5. Data Sharing</H2>
            <P>
                We never sell your personal data. We share data only with:
            </P>
            <UL>
                <li>AI providers needed to run our tools</li>
                <li>Analytics & advertising partners (anonymized)</li>
                <li>Legal authorities when required by law</li>
            </UL>

            <H2>6. Children's Privacy</H2>
            <P>
                Our site is not directed at children under 13. We do not
                knowingly collect personal information from children. If you
                believe we have, please contact us so we can delete it.
            </P>

            <H2>7. Your Rights</H2>
            <P>
                Depending on your location, you may have the right to access,
                correct, or delete your personal data. To exercise these rights,
                contact us at <b>freeaiwriters@gmail.com</b>.
            </P>

            <H2>8. Changes to This Policy</H2>
            <P>
                We may update this Privacy Policy occasionally. The "Last
                updated" date at the top reflects the most recent revision.
                Continued use of the site after changes implies acceptance.
            </P>

            <H2>9. Contact Us</H2>
            <P>
                Questions about this Privacy Policy? Email us at{" "}
                <b>freeaiwriters@gmail.com</b> or use our{" "}
                <a href="/contact" className="underline font-bold">
                    contact page
                </a>
                .
            </P>
        </LegalLayout>
        </>
    );
}
